import React, {Component} from 'react'
import {Typography} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles';
import FontW9 from "../Font/FontW9";

const styles = theme => ({
    title: {
        alignContent: 'center',
        textAlign: 'center',
        fontFamily: 'seo goe ui light',
        color: "white",
        fontSize: '36pt',
        paddingTop: '40vh',
        [theme.breakpoints.down('sm')]: {
            fontSize: '30pt',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '20pt',
        },
        display:"block",
        margin:'auto'
    },
    fontFocus: {
        fontSize: '32pt',
        [theme.breakpoints.down('sm')]: {
            fontSize: '26pt',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '20pt',
        },
    },
    font50: {
        fontSize: '50pt',
        [theme.breakpoints.down('sm')]: {
            fontSize: '41pt',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '29pt',
        },
    },
    picture: {
        backgroundColor: 'black',
        position: 'absolute',
        height: '130%',
        zIndex: 1,
    },
    root: {
        backgroundImage: "url('img/people.png')",
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#8DC21F',
    },
    div2: {
        height: '700px',
        [theme.breakpoints.down('xs')]: {
            height: '400px',
        },
    }
})

class Clients extends Component {
    state = {
        width: window.innerWidth,
        height: window.innerHeight,
        percent: '100%'
    }

    componentDidMount() {
        window.addEventListener('resize', (event) => {
            this.setState({width: event.currentTarget.innerWidth, height: event.currentTarget.innerHeight})
            if (event.currentTarget.innerWidth < 980) {
                let nextpercent = event.currentTarget.innerWidth / 980 * 100
                this.setState({percent: `${nextpercent} %`})
            }
        }, true)
    }

    render() {
        const {classes} = this.props
        // return (
        //     <div data-scroll-index="6" className="full-height-flex clearfix "
        //          style={{ position: 'relative', overflow: 'hidden', background: '#8DC21F', height: '600px' }}>
        //         <div className={classes.opacityClient}>
        //         </div>
        //         <div className={classes.picture}>
        //             <img src="img/people.png" style={{ height: '100%' }}/>
        //         </div>
        //         <Typography
        //             className={classes.title}
        //         >
        //             <span className={classes.fontFocus}>
        //                 <FontW9>Focus on who you really are.</FontW9><br/>
        //             </span>
        //             <span className={classes.font50}><FontW9  >本当は何者であるのか<br/>
        //                 にフォーカスせよ。</FontW9></span>
        //         </Typography>
        //     </div>
        // )
        let size = {}
        if (this.state.width >= 980) {
            size = {
                backgroundSize: '1155px 1155px',
            }
        } else {
            let newwidth = this.state.width / 980 * 1155

            size = {
                backgroundSize: `${newwidth}px `,
            }
        }
        // let newHeight = this.state.width / 980 * 700
        return (
            <div className={classes.root} style={size}>
                <div style={{width: '100%', height: '100%', backgroundColor: 'black', opacity: 0.6}}>
                    <div style={{maxWidth: '980px', height: `100vh`, margin: 'auto'}}>
                            <Typography
                                className={classes.title}
                            >
                                <span className={classes.fontFocus}>
                                    <FontW9>Focus on who you really are.</FontW9><br/>
                                </span>
                                <span className={classes.font50}><FontW9>本当は何者であるのか<br/>
                                    にフォーカスせよ。</FontW9></span>
                            </Typography>
                    </div>
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(Clients)
